import React, { useContext, useEffect, useState } from 'react';
import Header from '../Integration/Header';
import '../../Css/checkout.css';
import PaymentMethod from '../Integration/PaymentMethod'
import { StateContext } from '../../Middleware/context/StateProvider';
import SummaryCard from '../Integration/SummaryCard';
import ClickAwayListener from '@mui/material/ClickAwayListener';


function CheckOut() {
  const { state } = useContext(StateContext); 
   const [method, setMethod] = useState('visa');
  const basket = state.basket;

  const total = basket.reduce(
    (sum, item) => sum + ((item.price * item.quantity)+(item.quantity*item.taxa)),
    0
  );

 
  //----------------------------

  

  //-----------------------------------------------------------------------------

  return ( <>
   <Header /> 
   <div className="payment-page"> 
    <div className="payment-container"> 
  {/* RESUMO */} 
  <aside className="payment-summary"> 
    <h3>Resumo da Compra</h3>
     <p>Itens: {basket.length}</p>
      <p className="total">Total: Kz {total.toLocaleString()}</p>
   <div className="Payment_items">
     {basket.map((item, index) => (
       <SummaryCard  key={index}  {...item}   /> ))} 
     </div>
      </aside> {/* PAGAMENTO */} 
      <section className="payment-box"> <h2>Escolha o método de pagamento</h2> 
     <div className="payment-tabs"> 
      <button onClick={() => setMethod('visa')} className={method === 'visa' ? 'active' : ''}>Visa</button>
       <button onClick={() => setMethod('iban')} className={method === 'iban' ? 'active' : ''}>Transferência</button>
      <button onClick={() => setMethod('ref')} className={method === 'ref' ? 'active' : ''}>Express</button> 
      <button onClick={() => setMethod('paypal')} className={method === 'paypal' ? 'active' : ''}>PayPal</button>
       </div> 
  <PaymentMethod type={method} basket={basket} custoTotal={total}/> 
  </section> 
  </div>
   </div> 
   </> );
}

export default CheckOut;
